import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const extractYouTubeId = (url = "") => {
  const m = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^&?/]+)/,
  );
  return m ? m[1] : null;
};

export default function VideoProjects() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/videos/latest`);
        const data = await res.json();
        setVideos(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching videos:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section id="films" className="section-dark">
      <div className="shell">
        <div className="section-head">
          <div>
            <p className="eyebrow">Films</p>
            <h2 className="section-title">
              Recent <em>videos.</em>
            </h2>
          </div>
          <Link to="/ViewVideos" className="link-arrow">
            All Videos
          </Link>
        </div>

        {loading ? (
          <div className="loader-wrap">
            <div className="loader" />
          </div>
        ) : videos.length === 0 ? (
          <p className="empty-state">No films uploaded yet.</p>
        ) : (
          <div className="video-grid">
            {videos.map((v) => {
              const id = extractYouTubeId(v.youtubeUrl);
              return (
                <div className="video-card" key={v._id}>
                  <div className="video-frame">
                    {id && (
                      <iframe
                        src={`https://www.youtube.com/embed/${id}`}
                        title={v.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    )}
                  </div>
                  <div className="video-body">
                    <h3>{v.title}</h3>
                    <p className="video-desc">{v.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
